<script>
    export default {
        props: {
            classes: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            columns: {
                type: Array,
                default:[],
                required: true
            },
            buttons: {
                type: Object,
                required: true
            },
            rows: {
                type: String,
                required: true
            },

        }
    };
</script>

<template>
    <div :class="classes">
        <div class="card">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-sm-4">
                        <h4 class="card-title mb-4">{{ title }}</h4>
                    </div>
                    <div class="col-sm-8" v-if="buttons.istrue">
                        <div class="text-sm-end">
                            <a v-if="buttons.createurl.length" :href="buttons.createurl" class="btn btn-success waves-effect waves-light mb-2 me-2" v-html="buttons.createbutton"></a>
                            <a :href="buttons.viewurl" class="btn btn-success waves-effect waves-light mb-2" v-html="buttons.viewbutton"></a>
                        </div>
                    </div>
                </div>
                
                <div class="table-responsive">
                    <table class="table mb-0">
                        <thead class="table-light">
                            <tr>
                                <th v-for="(column,index) in columns" :key="index" style="column.width" class="align-middle">{{ column.title }}</th>
                            </tr>
                        </thead>
                        <tbody v-html="rows">
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>